export const iconFontAwesomeConnectivityHouseSignal = (
	<i className="fa-solid fa-house-signal"></i>
);
